
import Prompt from '../prompt/Prompt'

const Prompts = ({ prompts, onDelete, onChange, onChangeWho, onMoveUp, onMoveDown, onEdit }) => {

  return (
    <div>
    
      {prompts?.map((prompt, idx) => (
       
        <Prompt
          key={prompt.id}
          disableMoveUp={idx === 0}
          disableMoveDown={idx === (prompts.length - 1)}
          prompt={prompt}
          onDelete={onDelete}
          onChange={onChange}
          onChangeWho = {onChangeWho}
          onMoveUp={onMoveUp}
          onMoveDown={onMoveDown}
          seqid={idx+1}
          total = {prompts.length}
          onEdit={onEdit} />
  
      ))}
      
   
    </div>
  )
}

export default Prompts